import React, { useState } from 'react'

// styles 
import {
	LoginContainer,
	Heading,
	PageLinking,
	Button
} from "./styles";

// form input
import AppFormikInput from "utlis/helpers/forms/AppFormikInput";

// bootstrap
import { Modal } from "react-bootstrap";

// modal
import ResetPasswordModal from './Modals/ResetPasswordModal';

// react router
import { Link } from 'react-router-dom';

export default function Login(props) {
	// props
	const {
		formik,

		buttonLoading,
		buttonDisable
	} = props

	// states
	const [resetPasswordModalVisibility, setResetPasswordModalVisibility] = useState(false)

	// reset passowrd
	const handleResetPasswordModalClose = () => {
		// reset passowrd modals
		setResetPasswordModalVisibility(false)
	}

	return (
		<LoginContainer className="container">
			<div className="d-flex flex-wrap mx-auto mb-3 login-inner">
				{/* left side */}
				<div className="col-sm-6 col-12 pe-sm-3">
					<div className="pb-3">
						{/* <Heading>Join us or sign in</Heading> */}
						<Heading>Sign in</Heading>
						<PageLinking>
							<span>Store</span> &ensp;/&ensp; <span>Sign In</span>
						</PageLinking>
					</div>
					<div className="st-fs-17">
						Track your future orders, checkout faster, and sync your favorites.
						Just login to your account and you'll be able to do that.
					</div>
				</div>

				{/* Right side */}
				<div className="col-sm-6 col-12 ps-sm-3">
					<div className="pt-5">
						<form onSubmit={formik.handleSubmit} noValidate autoComplete="off">
							<AppFormikInput
								inputType={"email"}
								formik={formik} // formik object
								stFormclassName={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Email Address"} // placeholder for the input
								formikFieldName={"email"} // important: formik value name for the input
							/>

							<AppFormikInput
								inputType={"password"}
								formik={formik} // formik object
								stFormclassName={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Password"} // placeholder for the input
								formikFieldName={"password"} // important: formik value name for the input
							/>

							<div className="info text-end position-relative" style={{ top: -3 }}>
								<a href="/" className="st-fs-14" onClick={ev => {
									ev.preventDefault()
									// show modal
									setResetPasswordModalVisibility(true)
								}}>Forgot Password?</a>
							</div>

							<div className="btns d-flex justify-content-center pt-3">
								<Button type="submit" disabled={buttonDisable} className="mb-0">
									{buttonLoading ? (
										<div
											className="spinner-border spinner-border-sm"
											role="status"
										/>
									) : (
										<span>Login</span>
									)}
								</Button>
							</div>

							<div className="info text-center position-relative mt-3">
								<span className="st-fs-16">
									Don't have an account?
								</span>
								<Link to="/register" className="ms-2 st-fs-16 st-fw-600 hover-underline-link">Join Us</Link>
							</div>
						</form>
					</div>
				</div>
			</div>


			{/* modals */}
			<Modal show={resetPasswordModalVisibility} onHide={handleResetPasswordModalClose}>
				<Modal.Body>
					<ResetPasswordModal
						email={formik.values.email}
						closeModal={handleResetPasswordModalClose}
					/>
				</Modal.Body>
			</Modal>

		</LoginContainer>
	)
}
